/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Alert API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  AlertCountResponse,
  AlertHistoryMetricsResponse,
  AlertHistoryRequestBody,
  AlertListV9Response,
  GetV9AlertsHistoryCountParams,
  PostV9AlertsHistoryParams,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary getAlertHistory
 */
export const postV9AlertsHistory = (
  alertHistoryRequestBody: MaybeRef<AlertHistoryRequestBody>,
  params?: MaybeRef<PostV9AlertsHistoryParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  alertHistoryRequestBody = unref(alertHistoryRequestBody);
  params = unref(params);

  return customAxiosInstance<AlertListV9Response>(
    {
      url: `/api/v9/alerts/history`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: alertHistoryRequestBody,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV9AlertsHistoryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV9AlertsHistory>>,
    TError,
    { data: BodyType<AlertHistoryRequestBody>; params?: PostV9AlertsHistoryParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV9AlertsHistory>>,
  TError,
  { data: BodyType<AlertHistoryRequestBody>; params?: PostV9AlertsHistoryParams },
  TContext
> => {
  const mutationKey = ['postV9AlertsHistory'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV9AlertsHistory>>,
    { data: BodyType<AlertHistoryRequestBody>; params?: PostV9AlertsHistoryParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV9AlertsHistory(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV9AlertsHistoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV9AlertsHistory>>
>;
export type PostV9AlertsHistoryMutationBody = BodyType<AlertHistoryRequestBody>;
export type PostV9AlertsHistoryMutationError = ErrorType<unknown>;

/**
 * @summary getAlertHistory
 */
export const usePostV9AlertsHistory = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV9AlertsHistory>>,
      TError,
      { data: BodyType<AlertHistoryRequestBody>; params?: PostV9AlertsHistoryParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV9AlertsHistory>>,
  TError,
  { data: BodyType<AlertHistoryRequestBody>; params?: PostV9AlertsHistoryParams },
  TContext
> => {
  const mutationOptions = getPostV9AlertsHistoryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 알람 히스토리 개수 조회
 */
export const getV9AlertsHistoryCount = (
  params: MaybeRef<GetV9AlertsHistoryCountParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<AlertCountResponse>(
    { url: `/api/v9/alerts/history/count`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV9AlertsHistoryCountQueryKey = (
  params?: MaybeRef<GetV9AlertsHistoryCountParams>,
) => {
  return ['api', 'v9', 'alerts', 'history', 'count', ...(params ? [params] : [])] as const;
};

export const getGetV9AlertsHistoryCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getV9AlertsHistoryCount>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV9AlertsHistoryCountParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV9AlertsHistoryCount>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV9AlertsHistoryCountQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV9AlertsHistoryCount>>> = ({
    signal,
  }) => getV9AlertsHistoryCount(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV9AlertsHistoryCount>>,
    TError,
    TData
  >;
};

export type GetV9AlertsHistoryCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV9AlertsHistoryCount>>
>;
export type GetV9AlertsHistoryCountQueryError = ErrorType<unknown>;

/**
 * @summary 알람 히스토리 개수 조회
 */

export function useGetV9AlertsHistoryCount<
  TData = Awaited<ReturnType<typeof getV9AlertsHistoryCount>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV9AlertsHistoryCountParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV9AlertsHistoryCount>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV9AlertsHistoryCountQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 알람 히스토리 시간 별 메트릭 조회
 */
export const postV9AlertsHistoryMetrics = (
  alertHistoryRequestBody: MaybeRef<AlertHistoryRequestBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  alertHistoryRequestBody = unref(alertHistoryRequestBody);

  return customAxiosInstance<AlertHistoryMetricsResponse>(
    {
      url: `/api/v9/alerts/history/metrics`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: alertHistoryRequestBody,
      signal,
    },
    options,
  );
};

export const getPostV9AlertsHistoryMetricsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV9AlertsHistoryMetrics>>,
    TError,
    { data: BodyType<AlertHistoryRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV9AlertsHistoryMetrics>>,
  TError,
  { data: BodyType<AlertHistoryRequestBody> },
  TContext
> => {
  const mutationKey = ['postV9AlertsHistoryMetrics'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV9AlertsHistoryMetrics>>,
    { data: BodyType<AlertHistoryRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV9AlertsHistoryMetrics(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV9AlertsHistoryMetricsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV9AlertsHistoryMetrics>>
>;
export type PostV9AlertsHistoryMetricsMutationBody = BodyType<AlertHistoryRequestBody>;
export type PostV9AlertsHistoryMetricsMutationError = ErrorType<unknown>;

/**
 * @summary 알람 히스토리 시간 별 메트릭 조회
 */
export const usePostV9AlertsHistoryMetrics = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV9AlertsHistoryMetrics>>,
      TError,
      { data: BodyType<AlertHistoryRequestBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV9AlertsHistoryMetrics>>,
  TError,
  { data: BodyType<AlertHistoryRequestBody> },
  TContext
> => {
  const mutationOptions = getPostV9AlertsHistoryMetricsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
